import axios from 'axios'
import { APP_HELPER } from '../../utils'

var mainInstance = axios.create({
	headers: {
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin': '*',
	},
})

const makeRequest =
	(instance) =>
	(method, url, ...params) => {
		// Set Language Headers
		mainInstance.defaults.headers.common['X-Plugin-Name'] = process.env.REACT_APP_PLUGIN_NAME
		mainInstance.defaults.headers.common['X-Plugin-Version'] = process.env.REACT_APP_PLUGIN_VERSION
		mainInstance.defaults.headers.common['Accept-Language'] = APP_HELPER.APP_LOCALE()
		// // Add a response interceptor
		instance.interceptors.response.use(
			(response) => {
				// trigger 'loading=false' event here
				return Promise.resolve(response)
			},
			(error) => {
				// trigger 'loading=false' event here
				return Promise.reject(error)
			}
		)
		return instance[method](url, ...params)
	}

const middlewareRequest =
	(method, url) =>
	(...params) => {
		return makeRequest(mainInstance)(method, url, ...params)
	}
export default middlewareRequest
